import React from "react";

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
};

export const TicketListItem = ({ ticket, selected, onSelect }) => {
  const statusClass = String(ticket.status || "open").toLowerCase().replace(/\s+/g, "-");
  const priorityClass = String(ticket.priority || "low").toLowerCase();
  const preview = ticket.description || ticket.email || "No recent message";
  const ticketCode = `SKBT-${String(ticket.id).padStart(3, "0")}`;
  const subject = ticket.subject || preview;

  return (
    <button
      type="button"
      className={`workspace-ticket-item ${selected ? "active" : ""}`}
      onClick={() => onSelect(ticket)}
    >
      <div className="workspace-ticket-row">
        <div className="workspace-ticket-content">
          <div className="workspace-ticket-top">
            <strong className="workspace-ticket-id">{ticketCode}</strong>
            <span>{formatDate(ticket.updatedAt || ticket.createdAt)}</span>
          </div>
          <p className="workspace-ticket-subject">{subject}</p>
        </div>
      </div>

      <div className="workspace-ticket-tags">
        <span className={`workspace-tag status-${statusClass}`}>{ticket.status || "Open"}</span>
        <span className={`workspace-tag priority-${priorityClass}`}>
          {ticket.priority || "Low"}
        </span>
      </div>
    </button>
  );
};

export default TicketListItem;
